<template>

    <b-notification
        type="is-light"
        :closable="false">
        <h1 class="subtitle">{{$t('PORTAL.SAUDACOES')}}<b>{{usuario.nomeCadastro}}</b> !</h1>
        <p>{{$t('PORTAL.INSTRUCOES')}}</p>   
    </b-notification>            

</template>


<script>
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
            };
        },
        computed: {
            ...mapState([
                'config',
                'usuario'
            ])
        }
    }

</script>